import { createSlice } from '@reduxjs/toolkit';

export const GAME_STATUS = {
  IDLE: 'IDLE',
  FLY: 'FLY',
  ENDING: 'ENDING',
};

const statusSlice = createSlice({
  name: 'status',
  initialState: GAME_STATUS.IDLE,
  reducers: {
    setStatus(state, action) {
      return action.payload;
    },
  },
});

export const { setStatus } = statusSlice.actions;
export default statusSlice.reducer;
